import React from 'react'
import { useContext, useState } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import BookTripDetails from './BookTripDetails'
import BookTripFlextime from './BookTripFlextime'
import MyLocation from '../comps/MyLocation.js'
import TripInfo from '../comps/TripInfo'
import {AppContext} from '../context/AppContext'
import {ReactComponent as BusIcon} from '../images/icon_bus.svg'
import {ReactComponent as TaxiIcon} from '../images/icon_taxi.svg'
import {ReactComponent as EvtolIcon} from '../images/icon_evtol.svg'


const BookTripCommute = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)


  // const [commuteOptions.from, setCommuteOptions.from] = useState('commute-bus')
  // const [commuteOptions.to, setCommuteOptions.to] = useState('commute-evtol')

  //const [commuteOptions, setCommuteOptions] = useState(AppContext)
  const {commuteOptions, setCommuteOptions} = useContext(AppContext)

  const selectFrom = (e) => {
      let thisId = e.currentTarget.id
      
      setCommuteOptions(prev => {
        console.log('updating commute from')
        console.log(commuteOptions.from)
        return {...prev, from: thisId}
       
      })
  }

  const selectTo = (e) => {
    let thisId = e.currentTarget.id
    setCommuteOptions(prev => {
      console.log('updating commute to')
      return {...prev, to: thisId}
    })
}


  const {tripDetails, prevPage, setPrevPage, nextPage, setNextPage, infoShow, setInfoShow, closestAirports} = useContext(AppContext)

  setPrevPage("/booktrip/flextime")
  setNextPage("/booktrip/done")
  console.log(prevPage)
  // setInfoShow(true);
  

  return (
    <div ID="choose-commute" className="content">
        <div className="content-wrap">
         <h2>Choose travel to/from airport(s)</h2>
        </div>
        <div className="commute-from commute-box">
          <h4><i>{tripDetails.location}</i></h4><small><h5>to</h5></small><span className="airports-from"><h4>{closestAirports.from && `${closestAirports.from[0].name} (${closestAirports.from[0].abbreviation})`   }</h4></span>
          <div className="commute-options button-group ">
            <button onClick={selectFrom} id="commute-bus" className={`button icon-button commute-item` + (commuteOptions.from == 'commute-bus' ? " selected" : "")}>
              <BusIcon />
              <h4>Bus</h4>
            </button>
            <button onClick={selectFrom}  id="commute-taxi" className={`button icon-button commute-item` + (commuteOptions.from == 'commute-taxi' ? " selected" : "")}>
              <TaxiIcon />
              <h4>Taxi</h4>
            </button>
            <button onClick={selectFrom}  id="commute-evtol" className={`button icon-button commute-item` + (commuteOptions.from == 'commute-evtol' ? " selected" : "")}>
              <EvtolIcon />
              <h4>eVTOL</h4>
            </button>
          </div>
        </div>
        <div className="commute-to commute-box">
          <h4><i>{tripDetails.destination}</i></h4><small><h5>to</h5></small><span className="airports-from"><h4>{closestAirports.to && `${closestAirports.to[0].name} (${closestAirports.to[0].abbreviation})`   }</h4></span>
          <div className="commute-options button-group ">
            <button onClick={selectTo} id="commute-bus" className={`button icon-button commute-item` + (commuteOptions.to == 'commute-bus' ? " selected" : "")}>
              <BusIcon />
              <h4>Bus</h4>
            </button>
            <button onClick={selectTo}  id="commute-taxi" className={`button icon-button commute-item` + (commuteOptions.to == 'commute-taxi' ? " selected" : "")}>
              <TaxiIcon />
              <h4>Taxi</h4>
            </button>
            <button onClick={selectTo}  id="commute-evtol" className={`button icon-button commute-item` + (commuteOptions.to == 'commute-evtol' ? " selected" : "")}>
              <EvtolIcon />
              <h4>eVTOL</h4>
            </button>
          </div>
        </div>
      </div>
  )
}

export default BookTripCommute
